import { render, staticRenderFns } from "./RmpText.vue?vue&type=template&id=9f9bb42a"
import script from "./RmpText.vue?vue&type=script&setup=true&lang=ts"
export * from "./RmpText.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports